import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../contexts/user'
import { LanguageContext } from '../../contexts';
import { env } from '../../config'
import styles from './payment.module.scss';
import Loader from '../../components/Loader';
import { useLabels } from '../../hooks';

const pageKey = "payment";

// Map language codes to full names
const languageMap = {
  'he': 'Hebrew',
  'en': 'English'
};

const IframePayment = ({ subscription, isLetPurchase }) => {
  const { hasPermissions, userType, orgData, codeDeliveryDetails, userData, getJwtToken, listProducts } = useContext(UserContext);
  const { language } = useContext(LanguageContext);
  const { getLocalUrlByLanguage } = useLabels();
  const [Id, setId] = useState(1);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [details, setDetails] = useState();
  const [token, setToken] = useState();

  // Function to get full language name
  const getLanguage = () => {
    return languageMap[language] || 'Hebrew'; 
  };

  useEffect(() => {
    if (userData?.sub) {
      setDetails(
        {
          "subscriptionSku": subscription.SKU_priority,
          "guidUser": userData.sub,
          "language": getLanguage()
        }
      );
      setToken(getJwtToken())
    }
  }, [subscription, userData, userType, language]);

  useEffect(() => {
    if ((userType != "GUEST" && listProducts && listProducts.length == 0 && details) || (userType != "GUEST" && listProducts && details && isLetPurchase)) {
      const fetchIframeUrl = async () => {
        try {
          const response = await fetch(`${env.REACT_APP_BILLING_API_URL}/Pelecard/getIframe`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(details),
          });
          if (!response.ok) {
            throw new Error('Failed to fetch iframe URL');
          }

          const data = await response.json();
          setIframeUrl(data.URL);
        }
        catch (error) {
          console.error('Error loading iframe:', error);
        }
      };
      if (details) {
        fetchIframeUrl();
      }
    }
  }, [details, listProducts, userType, userData, isLetPurchase]);

  if (!iframeUrl) return <Loader/>;

  return (
    <div>
      {iframeUrl &&
        <iframe className={styles.iframe}
          src={iframeUrl}
          width="600"
          height="800"
          margin="auto"
          title="Description of iframe content"
          style={{ border: 'none' }}
        />}
    </div>

  );
};

export default IframePayment;